import React from "react";
import { getTagUrl } from "cube-components/blog/TagUrl";

export interface TagProps {
  name: string;
}

export const Tag = ({ name }: TagProps) => {
  return (
    <li>
      <a href={getTagUrl(name)}
         className="hover:text-lucid-300"
         rel="follow"
      >
        #{name}
      </a>
    </li>
  );
};

export interface TagsListProps {
  tags: string[];
}

const TagsList = ({ tags }: TagsListProps) => {
  return (
    <ul className="
    flex gap-3
    items-center
    justify-start
    py-2
    px-3
    md:px-5
    border
    border-lucid-700
    bg-lucid-800
    rounded-full shadow-inner shadow-lucid-900
    overflow-x-auto
    "
    >
      {tags.map(tag => (
        <Tag key={tag}
             name={tag}
        />
      ))}
    </ul>
  );
};

export default TagsList;
